/**
 * Spacing multiplier. `theme.spacing(n)` returns `${n * 8}px`, so the
 * canonical 8-pt scale (8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96) maps
 * to `theme.spacing(1..12)` directly. Components must consume via
 * `theme.spacing(...)`, never raw px.
 */
export const spacing = 8;
